import _define_property from "@swc/helpers/src/_define_property.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Toolbar from "@material-ui/core/Toolbar";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import { grey } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import StatusPage from "../../components/status-page";
import { VersionContext } from "../../contexts/version";
import * as helpers from "../../helpers";
import Link from "../../link/contrast";
var infoSiteURI = "https://www.blackbird.online";
var useStyles = makeStyles(function(theme) {
    var _obj;
    return {
        wrapLinks: _define_property({
            whiteSpace: "normal"
        }, theme.breakpoints.down("sm"), {
            textAlign: "center"
        }),
        verticalPadding: {
            padding: theme.spacing(2)
        },
        bar: (_obj = {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            position: "relative",
            whiteSpace: "nowrap"
        }, _define_property(_obj, theme.breakpoints.down("xs"), {
            padding: "1em"
        }), _define_property(_obj, "boxShadow", "none"), _obj),
        contentJustification: _define_property({
            justifyContent: "space-between"
        }, theme.breakpoints.down("xs"), {
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center"
        }),
        stagingStriped: {
            backgroundImage: "repeating-linear-gradient(-45deg, ".concat(theme.palette.primary.main, ", ").concat(theme.palette.primary.main, " 10px, rgba(255, 255, 255, 0.075) 10px, rgba(255, 255, 255, 0.075) 20px)")
        },
        version: _define_property({
            color: grey["500"]
        }, theme.breakpoints.down("sm"), {
            display: "block",
            textAlign: "center"
        }),
        plainLink: {
            color: "#FFB200",
            textDecoration: "none"
        }
    };
});
var joinWithPipe = helpers.joinWith(" | ");
var Footer = function(param) {
    var helpLink = param.helpLink, gettingStartedLink = param.gettingStartedLink, whatsNewLink = param.whatsNewLink, _hideSupportLink = param.hideSupportLink, hideSupportLink = _hideSupportLink === void 0 ? false : _hideSupportLink;
    var classes = useStyles();
    var ref = _sliced_to_array(useTranslation(), 1), t = ref[0];
    var ref1 = useContext(VersionContext), commit = ref1.commit, version = ref1.version;
    var year = new Date().getFullYear();
    var supportParts = [];
    supportParts.push(/*#__PURE__*/ React.createElement(StatusPage, null));
    if (gettingStartedLink) {
        supportParts.push(/*#__PURE__*/ React.createElement(Link, {
            href: "".concat(gettingStartedLink)
        }, t("shared:gettingStarted", "Getting started")));
    }
    if (helpLink) {
        supportParts.push(/*#__PURE__*/ React.createElement(Link, {
            href: "".concat(helpLink)
        }, t("shared:help", "Help")));
    }
    if (whatsNewLink) {
        supportParts.push(/*#__PURE__*/ React.createElement(Link, {
            href: "".concat(whatsNewLink),
            target: "_blank",
            rel: "noopener noreferrer"
        }, t("shared:whatsNew", "What's new")));
    }
    supportParts.push(/*#__PURE__*/ React.createElement(Link, {
        href: "".concat(infoSiteURI, "/about")
    }, t("shared:about", "About")));
    supportParts.push(/*#__PURE__*/ React.createElement(Link, {
        href: "".concat(infoSiteURI, "/contact")
    }, t("shared:contact", "Contact")));
    if (!hideSupportLink) {
        supportParts.push(/*#__PURE__*/ React.createElement(Link, {
            href: "".concat(infoSiteURI, "/support")
        }, t("shared:support", "Support")));
    }
    var isStaging = !!(version && !/^v\d+\.\d+\.\d+$/.test(version));
    // FIXME: Find out where to set position="static" on the new MUI paper component.
    return /*#__PURE__*/ React.createElement(Paper, {
        square: true,
        component: "footer",
        elevation: 4,
        className: clsx(classes.bar, _define_property({}, classes.stagingStriped, isStaging))
    }, /*#__PURE__*/ React.createElement(Toolbar, {
        className: classes.verticalPadding
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 0,
        className: classes.contentJustification
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        sm: 6
    }, /*#__PURE__*/ React.createElement(Typography, {
        color: "inherit",
        variant: "subtitle1"
    }, "\xa9 ".concat(year, " Blackbird ApS. All rights reserved. "), commit && version ? /*#__PURE__*/ React.createElement(Tooltip, {
        placement: "top",
        title: "Build ".concat(commit)
    }, /*#__PURE__*/ React.createElement("span", {
        className: "".concat(classes.version, " hideInPercy")
    }, "Version ".concat(version))) : null)), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        sm: 6,
        className: "hideInPercy"
    }, /*#__PURE__*/ React.createElement(Typography, {
        className: classes.wrapLinks,
        align: "right",
        color: "inherit",
        variant: "subtitle1"
    }, supportParts.reduce(joinWithPipe, []))))));
};
export default Footer;
